export default __webpack_public_path__ + "static/media/3029.dcbc35ee.jpg";